<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title> Prüfungen </ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list class="dark:bg-darklist p-0">
      @for (exam of exams(); track trackById()) {
        <ion-item
          button
          (click)="openExam(exam)"
          detail="true"
        >
          <ion-label>
            <h2>{{ exam.StartTime | date:"MMM dd, yyyy HH:mm" }}</h2>
            <p> {{ exam.PassedTest === true ? "Bestanden" : exam.PassedTest === false ? "Nicht Bestanden" : "Unbekannt" }}</p>
          </ion-label> 
        </ion-item>
      }
    </ion-list>
    @if (!exams() || !exams().length) {
      <app-no-selection
        label="Keine Prüfungen"
        icon="school-outline"
        color="medium"
        class="h-full"
    ></app-no-selection>
    }
</ion-content>

